import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from "react";
type AgentModalContextType = {
  isAgentModalOpen: boolean;
  setIsAgentModalOpen: Dispatch<SetStateAction<boolean>>;
};
const AgentModalContext = createContext<AgentModalContextType | null>(null);

const AgentModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [isAgentModalOpen, setIsAgentModalOpen] = useState(false);
  return (
    <AgentModalContext.Provider
      value={{ isAgentModalOpen, setIsAgentModalOpen }}>
      {children}
    </AgentModalContext.Provider>
  );
};
export const useAgentModal = () => useContext(AgentModalContext);
export { AgentModalProvider };
